<template>
  <div
    v-if="updateModal"
    :class="$style.updateLoading"
  >
    <div :class="$style.processing">
      <animation-processing fill="new-blue" />
    </div>
    <span
      v-if="cancelling"
      class="mt-serif.mt-serif--size5"
      :class="$style.description"
    >
      {{ $t('pages.submissions.components.loading.live_loader_cancel_desc') }}
    </span>
    <span
      v-else
      class="mt-serif.mt-serif--size5"
      :class="$style.description"
    >{{ $t('pages.submissions.components.loading.live_loader_desc') }}</span>
  </div>
  <div
    v-else
    :class="$style.loading"
  >
    <div :class="$style.processing">
      <animation-processing fill="new-blue" />
    </div>
    <span
      class="mt-serif.mt-serif--size5"
      :class="$style.description"
    >{{ $t('pages.submissions.components.loading.description') }}</span>
  </div>
</template>

<script type="text/ecmascript-6">
import AnimationProcessing from 'components/animations/processing'

export default {
  name: 'SubmissionLoading',

  components: {
    AnimationProcessing
  },
  props: {
    updateModal: {
      type: Boolean,
      default: false
    },
    cancelling: {
      type: Boolean,
      default: false
    }
  }
}
</script>
<style lang="scss" src="./index.scss" module></style>
